import { Bus } from 'baconjs'

class UiSocketRestDispatcher {
  constructor(opts) {
    const domain = opts.domain
    this.worker = opts.worker
    this.domains = {}
    this.domains[domain] = new Bus()

    // any responses from the worker get forwarded to socketRestClient
    this.receiver = this.domains[domain]
  }

  send(data) {
    this.worker.postMessage({
      eventType: 'rest',
      message: data
    })
  }
}

export default UiSocketRestDispatcher
